import { Typography, Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";
import { ButtonBase } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  message: string;
  onClose?: () => void;
};

const InlineErrorContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  cursor: text;
  button {
    color: ${(p) => p.theme.colors.error};
    padding: 0.125rem;
    font-size: ${(p) => p.theme.text.fontSizes.l};
    border-radius: 0.25rem;
    cursor: pointer;
    &:hover {
      background-color: ${(p) => p.theme.colors.error}22;
    }
  }
`;

export const InlineError = (props: Props) => {
  const { message, onClose } = props;
  return (
    <InlineErrorContainer>
      <Typography
        variant="body2"
        color="error.main"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {message}
      </Typography>
      {onClose && (
        <ButtonBase
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <CloseIcon fontSize="inherit" />
        </ButtonBase>
      )}
    </InlineErrorContainer>
  );
};
